// extracted by mini-css-extract-plugin
module.exports = {"wrap":"AlertMessage_wrap_2bkZ_"};